import { Header as HeaderWidget } from "@/components/header/index";
import { SectionPage } from "@/components/section-page";
import { LocalizationText } from "@/app/index";
import { useHeaderStyles } from "./header.styles";
import { useContextSystemView } from "../../context/index";
import { useMemo } from "react";
import ProfileHeaderLogoSvg from "../../static/system-view-header-logo.svg?react";

export const Header = () => {
  const { styles } = useHeaderStyles();
  const { localization } = useContextSystemView();

  const breadcrumbItems = useMemo(
    () => [
      {
        title: <LocalizationText value="system.view.breadcrumb.home" />,
        href: `/${localization.currentLang}/home`,
      },
      {
        title: <LocalizationText value="system.view.breadcrumb.act.delegate" />,
      },
    ],
    [localization.currentLang],
  );

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <HeaderWidget
        icon={<ProfileHeaderLogoSvg />}
        title={<LocalizationText value="system.view.header.title" />}
        breadcrumbItems={breadcrumbItems}
      />
    </SectionPage>
  );
};
